export default __webpack_public_path__ + "static/media/kit.f28304f8.svg";